import { render } from "./TrainingSessionVideoDashboardView.vue?vue&type=template&id=c8991766&scoped=true"
import script from "./TrainingSessionVideoDashboardView.vue?vue&type=script&lang=js"
export * from "./TrainingSessionVideoDashboardView.vue?vue&type=script&lang=js"

import "./TrainingSessionVideoDashboardView.vue?vue&type=style&index=0&id=c8991766&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8991766"]])

export default __exports__